var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBaseball3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 83 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 8.8,
    y: 9.7,
    width: 63.9,
    height: 63.4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask0_11376_44161",
    "data-name": "mask0_11376_4416"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.2,
    cy: 41.2,
    r: 31.5,
    fill: "#fff"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mask0_11376_4416"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.2,
    cy: 41.2,
    r: 31.5,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M62.9,48.7c-9.4,13-27.6,15.9-40.6,6.5-7.6-5.5-11.8-14-12-22.8-3.6,12.5.8,26.5,12,34.6,14.3,10.3,34.2,7.1,44.4-7.1,8.1-11.2,7.8-25.8.5-36.6,2.5,8.4,1.2,17.8-4.3,25.4Z",
    fill: "#c9cacc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1,48.2l-3.3-3.3-.7,2,2.9,2.9-.7,1.8h5.1c0,.1.7-1.8.7-1.8h-4.5c0-.1.5-1.5.5-1.5Z",
    fill: "#ce152d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6,42.6l-2.5-3.8-1.1,1.8,2.2,3.4-1,1.6,5,1.1,1.1-1.8-4.4-1,.8-1.3Z",
    fill: "#ce152d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2,37.5l-1.7-4.3-1.4,1.5,1.5,3.7-1.3,1.4,4.6,2,1.4-1.5-4.2-1.8,1-1.1Z",
    fill: "#ce152d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8,33.3l-.8-4.5-1.7,1.2.7,4-1.6,1.1,4.2,2.9,1.7-1.2-3.7-2.6,1.3-.9Z",
    fill: "#ce152d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1,30v-4.6c.1,0-1.8.9-1.8.9v4c-.1,0-1.9.8-1.9.8l3.5,3.7,1.9-.9-3.1-3.3,1.4-.6Z",
    fill: "#ce152d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7,54.3l-3.8-2.6-.3,2.1,3.4,2.3-.3,1.9,5-.9.3-2.1-4.4.8.2-1.5Z",
    fill: "#ce152d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6,60.5l-4.2-1.8v2.1c.1,0,3.8,1.6,3.8,1.6v2c0,0,4.8-1.8,4.8-1.8v-2.1c-.1,0-4.3,1.6-4.3,1.6v-1.5Z",
    fill: "#ce152d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7,66.6l-4.5-.9.5,2,4,.8.5,1.9,4.2-2.7-.5-2-3.8,2.5-.4-1.5Z",
    fill: "#ce152d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,30h-5.1c0-.1-.7,1.8-.7,1.8h4.5c0,.1-.5,1.5-.5,1.5l3.3,3.3.7-2-2.8-2.9.7-1.8Z",
    fill: "#ce152d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2,35l-1.1,1.8,4.4,1-.8,1.3,2.5,3.9,1.1-1.8-2.2-3.4,1-1.7-5-1.1Z",
    fill: "#ce152d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4,39.7l-1.4,1.5,4.2,1.8-1,1.1,1.7,4.3,1.4-1.5-1.5-3.7,1.3-1.4-4.7-2Z",
    fill: "#ce152d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8,43.7l-1.7,1.2,3.7,2.6-1.3.9.8,4.5,1.7-1.2-.7-3.9,1.6-1.1-4.1-2.9Z",
    fill: "#ce152d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8,46.8l-1.9.9,3.1,3.3-1.4.6v4.6c-.1,0,1.8-.9,1.8-.9v-4c.1,0,1.9-.8,1.9-.8l-3.5-3.7Z",
    fill: "#ce152d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4,29.9l.3-2.1-3.4-2.3.3-1.9-5,.9-.3,2.1,4.4-.8-.2,1.5,3.8,2.6Z",
    fill: "#ce152d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8,21.6l4.2,1.8v-2.1c-.1,0-3.8-1.6-3.8-1.6v-1.9c-.1,0-4.8,1.8-4.8,1.8v2.1c.1,0,4.3-1.7,4.3-1.7v1.5Z",
    fill: "#ce152d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9,15.7l4.5.9-.5-2-4-.8-.5-1.9-4.2,2.7.5,2,3.8-2.5.4,1.5Z",
    fill: "#ce152d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBaseball3);
export default __webpack_public_path__ + "static/media/icon_baseball3.b2e65f702950f2d09f54573b4d2ca84c.svg";
export { ForwardRef as ReactComponent };